import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSubscriptionIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: 24,
	height: 24,
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2.5l2.97 6.02 6.65.97-4.81 4.69 1.13 6.62L12 17.9l-5.94 3.12 1.13-6.62L2.38 9.49l6.65-.97L12 2.5z" })
});
export default SvgSubscriptionIcon;
